import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=39ee5eba&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39ee5eba')) {
      api.createRecord('39ee5eba', component.options)
    } else {
      api.reload('39ee5eba', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=39ee5eba&", function () {
      api.rerender('39ee5eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gRx526JSnqot/JS/comp/childrenage.vue"
export default component.exports